import { request } from '@queries/apis/config'

export * from './auth'
export * from './user'
export * from './role'
export * from './taxonomy'
export * from './media'
export * from './post'
export * from './game'
export * from './game-quiz'
export * from './game-comment'
export * from './notification'
export * from './option'
export * from './reward-user'
export * from './reward'
export * from './special-deal'
export * from './special-deal-user'
export * from './transaction'
export * from './account'
export * from './event'
export * from './wish'
export * from './analytics'

export const postCleanCache = () => request({ url: 'system/clean-cache', method: 'POST' })
